import { FC } from "react";

import {
  MusicTabData,
  MusicTabOptions,
  SKUPageContentTabType,
} from "@/data/types";

import { AudioTabProvider } from "./audio-tab/audio-tab-context";
import { AudioTabHeader } from "./audio-tab/audio-tab-header";
import { AudioTabPlaylist } from "./audio-tab/audio-tab-playlist";
import { AudioTabSettings } from "./audio-tab/audio-tab-settings";
import { CMSTab } from "./cms-tab";
import { CMSTabProvider } from "./cms-tab-context";

type Props = {
  index: number;
  options: MusicTabOptions;
  tracks: MusicTabData[];
};

export const CMSAudioTab: FC<Props> = ({ index, options, tracks }) => (
  <CMSTabProvider tabType={SKUPageContentTabType.MUSIC_TAB} tabIndex={index}>
    <CMSTab options={options}>
      <AudioTabProvider options={options} data={tracks}>
        <div className="space-y-6">
          <AudioTabHeader />
          <AudioTabPlaylist />
          <AudioTabSettings />
        </div>
      </AudioTabProvider>
    </CMSTab>
  </CMSTabProvider>
);
